function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import ChartContext from './chart_context';
import { useTheme } from '@veneer/theme';
import chartTheme from './chart_theme';
var ChartProvider = _ref => {
  var {
    chartInterface: chartInterfaceProp,
    children
  } = _ref;
  var chartInterface = typeof chartInterfaceProp === 'function' ? chartInterfaceProp() : undefined;
  var veneerTheme = useTheme();
  var theme = React.useMemo(() => _objectSpread(_objectSpread({}, veneerTheme), chartTheme[veneerTheme.mode] || chartTheme.light), [veneerTheme]);
  var chartContextValue = {
    create: chartInterface ? chartInterface.create : undefined,
    lib: chartInterface ? chartInterface.lib : undefined,
    theme
  };
  return /*#__PURE__*/React.createElement(ChartContext.Provider, {
    value: chartContextValue
  }, children);
};
ChartProvider.propTypes = {
  children: PropTypes.node.isRequired,
  chartInterface: PropTypes.func
};
ChartProvider.defaultProps = {
  chartInterface: undefined
};
export default ChartProvider;